var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinnedChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.98436 1.18985L13.3082 4.51371C14.2224 5.42789 13.9723 6.96901 12.8159 7.54724L9.46096 9.22467C9.34022 9.28508 9.24786 9.39039 9.20377 9.51809L8.21242 12.3877C8.00476 12.9888 7.23953 13.165 6.78983 12.7154L4.65155 10.577L1.59389 13.6348H0.863281L0.863336 12.9042L3.92099 9.8465L1.7827 7.7082C1.33302 7.2585 1.50929 6.49327 2.11038 6.28561L4.98 5.29431C5.10766 5.2502 5.21297 5.15787 5.27337 5.03706L6.9508 1.68213C7.52902 0.525764 9.07015 0.275671 9.98436 1.18985ZM12.5777 5.24427L9.25378 1.92041C8.83824 1.50487 8.13769 1.61855 7.87492 2.14417L6.19749 5.4991C6.01627 5.86151 5.70033 6.13856 5.31734 6.27087L2.7079 7.17227L7.32576 11.7901L8.22723 9.18073C8.35954 8.7977 8.63657 8.48183 8.99893 8.30062L12.3539 6.62311C12.8795 6.36034 12.9932 5.6598 12.5777 5.24427Z",
    fill: "#97A0AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5777 5.24427L9.25378 1.92041C8.83824 1.50487 8.13769 1.61855 7.87492 2.14417L6.19749 5.4991C6.01627 5.86151 5.70033 6.13856 5.31734 6.27087L2.7079 7.17227L7.32576 11.7901L8.22723 9.18073C8.35954 8.7977 8.63657 8.48183 8.99893 8.30062L12.3539 6.62311C12.8795 6.36034 12.9932 5.6598 12.5777 5.24427Z",
    fill: "#97A0AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinnedChat);
export default __webpack_public_path__ + "static/media/pinned_chat.d44a6b526ebf1c80947c114fab567621.svg";
export { ForwardRef as ReactComponent };